{
  "devices_page": {
    "title": "Devices",
    "claim": "Claim"
  },
  "device_monitor_page": {
    "title": "Monitor Device"
  },
  "device_configuration_page": {
    "title": "Edit Device"
  },
  "device_create_configuration_page": {
    "title": "Create Device Configuration"
  },
  "device_admin_configuration_page": {
    "title": "Admin Device Configuration"
  },
  "monitor": {
    "index_title": "Monitor Device",
    "default_title": "Node %{node_id}",
    "general_info": "General Info",
    "recent_measurements": "Recent Measurements",
    "sensors": "Sensors (%{count})",
    "near_by": "Near by <span>%{location}</span>",
    "chart_tab": "Chart",
    "table_tab": "Table",
    "debug_tab": "Debug",
    "admin_settings_tab": "Admin",
    "wind_tab": "Wind",
    "wind_rose_tab": "Wind Rose",
    "wind_rose_empty_title": "Select parameters to view the wind rose",
    "wind_rose_empty_description": "Choose one wind speed and one wind direction parameter from the list on the right.",
    "wind_rose_speed": "Wind speed parameter",
    "wind_rose_direction": "Wind direction parameter",
    "files_tab": "Files",
    "delete": "Delete",
    "params": {
      "name": "Parameter"
    },
    "download_table_data": "Table Data",
    "download_chart_pdf": "Chart (pdf)",
    "download_wind_rose_pdf": "Wind Rose (pdf)",
    "print_chart": "Print chart",
    "download_chart": "Download",
    "toggle_measurements": "Toggle measurements",
    "live_debug_updates_toggle": "Toggle live debug updates",
    "live_debug_updates_stop": "Stop live updates",
    "live_debug_updates_resume": "Resume live updates",
    "select_measurements": "Please select parameters to view",
    "add_to_dashboard": "Add to dashboard",
    "hide": "Hide parameter",
    "show": "Show parameter",
    "manage_parameters_visibility": "Manage Parameters Visibility"
  },
  "thiamis": {
    "name": "Name",
    "description": "Description",
    "settings": "Settings",
    "bat_voltage": "Bat.voltage",
    "inventory": "Inventory",
    "device": "Device",
    "address": "Address",
    "parameters": "Parameters",
    "create": "Create",
    "more": "...",
    "errors": "Errors",
    "maintenance": "Maintenance",
    "status": "Status",
    "enabled": "Enabled",
    "debug": "Debug",
    "driver": "Driver",
    "driver_default": "Default",
    "driver_beta": "Beta",
    "calibrations": "Calibrations",
    "see_wifi_settings": "See WiFi settings of device",
    "thiamis_module": "Device Module",
    "airthinx": "Aethair",
    "select_airthinx": "Select Aethair",
    "leased_thiamis_module": "Leased Device Module",
    "list_title": "Device",
    "config_page_title": "Device Configuration",
    "config_page_breadcrumb": "Edit",
    "admin_page_breadcrumb": "Admin",
    "monitor_page_breadcrumb": "Monitor",
    "node_empty": "the node has no data points",
    "not_available_yet": "Not available yet",
    "add_sensor": "Add sensor",
    "save": "Save",
    "go_to_index": "Back to Device",
    "open_monitor": "Monitor",
    "edit_configuration": "Edit Device",
    "delete_thiamis": "Reset",
    "create_configuration": "Create Device Configuration",
    "revoke_lease": "Revoke Lease",
    "no_leased_shared_orgs": "No device shared or leased to any organization",
    "choose_node": "Choose node...",
    "select_debug_level": "Select Debug Level",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "manually": "Manually",
    "add_new_sensor": "Add Sensor",
    "node_serial": "Device's Serial",
    "location": "Device Location",
    "empty_name": "Device name",
    "select_network": "Choose network...",
    "empty_description": "Device description",
    "share_with": "Share with",
    "lease_with": "Lease with",
    "manage_thiamises": "Manage Device",
    "leased_to_org": "Leased to %{orgName}",
    "rotate_to_see_graph": "Rotate to see the graph",
    "map_address_placeholder": "Type address or coordinates...",
    "remove_from_chart": "Remove from chart",
    "billing": "Billing",
    "owner": "Owner",
    "external_organization": "External Organization",
    "unit": "Unit",
    "profile": "Profile",
    "debug_info": {
      "timestamp": "Timestamp",
      "message": "Message"
    },
    "debug_levels": {
      "info": "INFO"
    },
    "pm_config": {
      "dl": "dL",
      "ft": "CFT",
      "m3": "m3"
    },
    "voc_unit": {
      "ppm": "ppm",
      "ppb": "ppb"
    },
    "manage_help_text": "Please choose device first",
    "tooltips": {
      "manage_mode": "Turn on/off manage mode",
      "available_actions": "Actions",
      "leased_thiamis": "Leased Device can be viewed or configured only by organization which it was leased to",
      "location_determined": "Location determined",
      "location_determined_auto": "Location determined automatically",
      "location_determined_auto_wifi": "Location determined automatically from WiFi",
      "location_determined_manual": "Location determined manually",
      "reset": "Reset Device",
      "refresh_wifi_networks": "Refresh WiFi Networks",
      "manage_dialog_transfer_orgazanition": "Organization that owns the nodes and can manage them",
      "manage_dialog_transfer_billing_orgazanition": "Organization that will be billed for nodes usage"
    },
    "default_wifi_dialog": {
      "title": "Default WiFi Settings",
      "help_text": "In case GSM network is not available use the following WiFi settings to configure your mobile hotspot or router to tether the device and connect to the internet. Then you can input or scan for your local WiFi credentials on the console."
    },
    "manage_dialog": {
      "success": "Device has been %{action} successfuly",
      "sensor_added": "Sensor has been added successfuly",
      "error": "Error occurred, try again later or contact Netronix support",
      "share_help_text": "* Please note that you can't share Device which is leased or has been already shared more than 3 times.",
      "lease_help_text": "* Please note that after Device is leased you can't monitor or configure it",
      "remove_share_help_text": "",
      "remove_lease_help_text": "",
      "transfer_help_text": "* Please note that you can't transfer Device which is already leased<br />** Billing organization can be the same organization as Owner organization or <b>one of its partners</b>",
      "reset_help_text": "* Please note that reset Device will remove all information about share and lease. All entities like alerts, reports, dashboard widgets where this device is used need to be updated.",
      "share_error_when_leased": "Can't share Device which is leased",
      "share_error_when_already_shared": "Can't share Device which has been shared more than 3 times",
      "no_partnerships": "no partnership or common partnerships found",
      "reset_error": "Could not reset Device, please try again later or contact Support",
      "reset_success": "%{serial} has been reset successfully",
      "reset_confirm": "You are about to reset %{name} [%{serial}] device. Are you sure you want to continue?"
    },
    "more_info": {
      "nearby": "Nearby",
      "sensors": "Sensors",
      "status": "Status",
      "battery": "Battery Voltage<br />%{value}V",
      "battery_level": "Battery Level %{value}%",
      "gsm_signal_with_network": "%{network}<br />GSM Signal<br />%{value}",
      "gsm_signal": "GSM Signal<br />%{value}",
      "gsm_signal_na": "GSM Signal<br />Not Available",
      "wifi_signal": "%{network}<br />WiFi Signal<br />%{value}",
      "wifi_signal_na": "WiFi Signal<br />Not Available",
      "shared_to": "Shared to",
      "leased_to": "Leased",
      "shared_from": "Shared from",
      "leased_from": "Leased from",
      "last_updated_location": "Last Time Updated",
      "last_updated": "Last Time Reported"
    },
    "manage_actions": {
      "share": "Share",
      "share_past": "shared",
      "remove_share": "Remove Share",
      "remove_share_past": "removed share",
      "transfer": "Transfer",
      "transfer_past": "transfered",
      "lease": "Lease",
      "lease_past": "leased",
      "remove_lease": "Remove Lease",
      "remove_lease_past": "removed lease",
      "download": "Download",
      "download_past": "downloaded",
      "firmware": "Firmware Update",
      "firmware_past": "firmware updated",
      "delete": "Reset",
      "delete_past": "reset",
      "activate": "Activate",
      "activate_past": "activated",
      "deactivate": "Deactivate",
      "deactivate_past": "deactivated",
      "hibernate": "Hibernate",
      "hibernate_past": "hibernated",
      "payment_update": "Billing",
      "payment_update_past": "updated billing"
    },
    "view_on_map": "View on Map",
    "firmware_channels": {
      "stable": "Stable",
      "unstable": "Unstable",
      "testing": "Testing",
      "tsi": "TSI"
    },
    "states": {
      "activated": "Activated",
      "deactivated": "Deactivated",
      "hibernated": "Hibernated",
      "online": "Online",
      "offline": "Offline",
      "inventory": "Inventory",
      "leased": "Leased",
      "shared": "Shared",
      "excellent": "Excellent",
      "good": "Good",
      "satisfactory": "Satisfactory",
      "moderate": "Moderate",
      "poor": "Poor",
      "veryPoor": "Very Poor"
    },
    "config_tabs": {
      "sensors": "Sensors",
      "general": "General",
      "location": "Location",
      "access_rights": "Access Rights",
      "node_events": "Device Events"
    },
    "sesor_delete_success": "Sensor was deleted successfully",
    "sesor_create_success": "Sensor was created successfully",
    "sesor_update_success": "Sensor was updated successfully",
    "user_calibration": {
      "params_length": "Calibration parameters should be at least two",
      "params_format": "Calibration parameters should be comma separated numbers"
    },
    "location_update_success": "Location was updated successfully",
    "calibration_update_success": "VOC Calibration turned %{state}",
    "download_csv": {
      "devices": "Devices",
      "parameters": "Parameters",
      "from": "From",
      "to": "To",
      "parameters_data": "Parameters data",
      "table_data": "Table data",
      "download": "Download Data",
      "export": "Export..."
    },
    "manage": {
      "share": "Share Devices",
      "remove_share": "Remove Share from Devices",
      "transfer": "Transfer Devices",
      "lease": "Lease Devices",
      "remove_lease": "Remove Lease from Devices",
      "delete": "Reset Devices",
      "activate": "Activate Devices",
      "deactivate": "Deactivate Devices"
    },
    "dashboards": {
      "title": "Dashboards",
      "title_private": "Private Dashboard",
      "title_public": "Public Dashboard",
      "enabled": "Dashboard",
      "title_private_open": "Open Private Dashboard",
      "title_public_open": "Open Public Dashboard",
      "title_public_open_window": "Open in a new window",
      "pm_units": "PM",
      "temp_units": "Temperature",
      "temp_132:24_unit": "Fahrenheit (°F)",
      "temp_132:14_unit": "Celsius (°C)",
      "temp_228:12_unit": "Fahrenheit (°F)",
      "temp_228:2_unit": "Celsius (°C)",
      "pm_132:4_unit": "PM1",
      "pm_132:5_unit": "PM2.5",
      "pm_132:6_unit": "PM10",
      "pm_229:1_unit": "PM1",
      "pm_229:2_unit": "PM2.5",
      "pm_229:3_unit": "PM10",
      "voc_units": "VOC",
      "voc_140:11_unit": "EtOH",
      "voc_140:12_unit": "Isobutylene",
      "exposure_time": "Exposure Time",
      "theme": "Theme",
      "theme_dark": "Dark",
      "theme_light": "Light",
      "show_logo": "Show Organization Logo",
      "show_logo_missing_tooltip": "Organization logo is missing. Please upload it on the Organization Edit page."
    },
    "aqms": {
      "title": "AQMS",
      "automation": "AQMS",
      "speed": "Speed",
      "dfs": "DFS",
      "devices": "Connected Devices",
      "cron": "Scheduler",
      "no_template": "No Template found for AQMS"
    }
  },
  "sensor": {
    "title": "Sensor",
    "type": "Sensor Type",
    "stel_alert_conf": "STEL Alert",
    "speed_min_label": "Off",
    "speed_max_label": "100%",
    "auto_zero_min_label": "Off",
    "auto_zero_max_label": "24h",
    "auto_zero_btn": "Auto Zero",
    "add_statistics": "Add Statistics",
    "add_custom_calibration": "Custom Calibration",
    "configure_channels": "Configure Channels",
    "channel": "Channel",
    "select_channel": "Select Channel",
    "factory_calibration_profiles": "Factory Calibration Profiles",
    "no_added": "There are no Sensors added",
    "data_point": {
      "last_measurement": "Last Measurement",
      "calibration_params": "Calibration Params",
      "result": "After",
      "value": "Before",
      "id": "Data Point",
      "name": "Name",
      "func": "Function",
      "period": "Period",
      "interval": "Interval",
      "unit": "Unit",
      "min": "Min",
      "max": "Max",
      "remove_title": "Remove Statistical Parameter",
      "remove_calibration_title": "Remove Calibration Parameter",
      "add_title": "Add Statistical Parameter",
      "add_info": "Calculated from an existing parameter and recalculated every minute from the moment it's created; there are no values before that.",
      "add_info_items": [
        "**AVG**: rolling average over the selected period.",
        "**MAX** / **MIN**: rolling maximum / minimum over the selected period.",
        "**DIFF**: difference between two parameters at each reading, possibly on different devices (no period).",
        "Periods of 6 hours or longer are recalculated every hour."
      ],
      "add_custom_calibration_title": "Add Custom Calibration Parameter",
      "add_scale_title": "Configure Measurement for %{channel_name} (%{conf})",
      "add_link_title": "Configure Measurement for %{channel_name}",
      "add_scale_title_wo_channel": "Configure Measurement",
      "id_placeholder": "Select Data Point...",
      "func_placeholder": "Select Function...",
      "period_placeholder": "Select Period...",
      "interval_placeholder": "Select Interval..."
    },
    "configuration": {
      "photometric_calibration": "Photometric Calibration",
      "auto_zero_interval": "Auto Zero Interval",
      "debug": "Debug",
      "size_correction": "Size Calibration",
      "flow_calibration": "Flow Calibration",
      "calfactor": "Calibration Value",
      "pm1_stel_alert": "PM 1",
      "pm25_stel_alert": "PM 2.5",
      "pm4_stel_alert": "PM 4",
      "pm10_stel_alert": "PM 10",
      "total_stel_alert": "Total",
      "stel_timeout": "Timeout",
      "stel_alert_unit": "mg/m<sup>3</sup>",
      "enabled": "Status",
      "calibrate": "Calibrate",
      "calibration": "Calibration",
      "calibration_voc": "VOC Calibration",
      "firmware": "Firmware",
      "auto_zero": "Auto Zero",
      "cumulative_concentration_calibration": "Cumulative Concentration<br /><small>(calibration)</small>",
      "pump_run_time": "Pump Run Time",
      "fan_dac_value": "Fan DAC Value",
      "laser_dac_value": "Laser DAC Value",
      "filter_last_changed": "Filter Changed",
      "cumulative_concentration_filter_change": "Cumulative Concentration<br /><small>(filter change)</small>",
      "mode": "Mode",
      "sample_method": "Sample Method",
      "instrument_mode": "Instrument Mode",
      "exp_bd_status_alarm": "i/o EXP. BD. Status Alarm",
      "mib_status_alarm": "MIB Status Alarm",
      "motherboard_status_alarm": "Motherboard Status Alarm",
      "external_alarm_3": "External Alarm 3",
      "external_alarm_2": "External Alarm 2",
      "external_alarm_1": "External Alarm 1",
      "filters": "Filters",
      "profile": "Profile",
      "choose_profile": "Choose Profile",
      "measurement_mode": "Measurement Mode",
      "units": "Units",
      "channel_n": "Channel %{i}",
      "session_time": "Session Time",
      "temperature_unit": "Temperature Unit",
      "windspeed_unit": "Wind Speed Unit",
      "pressure_unit": "Pressure Unit",
      "precipitation_unit": "Precipitation Unit",
      "pm_microgram": "PM Unit",
      "us_units": "Imperial Units",
      "pm_ug_label": "µg",
      "pm_mg_label": "mg",
      "iccid": "ICCID",
      "imei": "IMEI",
      "mac": "MAC"
    },
    "profiles": {
      "mcerts": "MCERTS",
      "custom": "Custom",
      "factory": "Factory Defaults",
      "ambient": "Ambient"
    },
    "tooltips": {
      "profile": "Settings will be applied from chosen profile"
    }
  },
  "sensors": {
    "remove_sensor": "remove sensor",
    "no_serial": "# No serial"
  },
  "data_points": {
    "status_true": "Online",
    "status_OK": "Online",
    "status_false": "Offline"
  },
  "devices": {
    "navigation_title": "Devices",
    "title": "Devices",
    "not_found": "No results found",
    "actions": {
      "title": "Actions",
      "download": "Download",
      "table_data": "Table data",
      "parameters_data": "Parameters data",
      "devices": "Devices"
    },
    "statuses": {
      "ok": "Online",
      "disabled": "Disabled",
      "error": "Error",
      "empty": "No status",
      "activated": "Activated",
      "deactivated": "Deactivated",
      "hibernated": "Hibernated",
      "online": "Online",
      "offline": "Offline",
      "excellent": "Excellent",
      "good": "Good",
      "satisfactory": "Satisfactory",
      "moderate": "Moderate",
      "poor": "Poor",
      "veryPoor": "Very Poor"
    }
  },
  "nodes": {
    "choose_node": "Choose node...",
    "node_serial": "Node's Serial"
  },
  "claim": {
    "serials": "Serials",
    "organization": "Organization",
    "result": "Result",
    "serials_helper": "Use space, comma or new string for batch claiming",
    "claim_devices": "Claim devices",
    "claiming_devices": "Claiming...",
    "serial": "Serial",
    "status": "Status",
    "claimed": "Claimed",
    "failed": "Failed",
    "no_claimed_devices": "There are no claimed devices in your organization. Claim the device(s) and it will appear here.",
    "success_claim": "Devices have been claimed successfully!",
    "warning_claim": "Error occurred when claiming some of the devices.",
    "error_claim": "Error occurred when claiming devices!"
  }
}